import { useState } from 'react';
import { faqItems } from '@/mocks/faq';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqItems.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <section className="py-16 md:py-20 bg-background-100">
        <div className="max-w-[1200px] mx-auto px-4 md:px-6">
          <div className="text-center mb-12">
            <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900 mb-3">
              常见问题
            </h2>
            <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
              关于私密健康，你可能想知道的问题都在这里
            </p>
          </div>

          <div className="max-w-3xl mx-auto flex flex-col gap-3">
            {faqItems.map((item, index) => (
              <div
                key={index}
                className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden"
              >
                <button
                  className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
                  onClick={() => setOpenIndex(openIndex === index ? null : index)}
                >
                  <span className="font-heading text-sm md:text-base font-medium text-foreground-900 pr-4">
                    {item.question}
                  </span>
                  <span className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                    <i
                      className={`text-lg text-foreground-400 transition-transform duration-300 ${
                        openIndex === index ? 'ri-subtract-line' : 'ri-add-line'
                      }`}
                    ></i>
                  </span>
                </button>
                <div
                  className={`transition-all duration-300 ease-in-out overflow-hidden ${
                    openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                  }`}
                >
                  <p className="px-5 pb-5 text-sm text-foreground-600 leading-relaxed">
                    {item.answer}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}